<div class="description-wrapper">
    <div class="description-time" *ngIf="tournamentStartDateLocal<=now && isRegularTournament()?.tournamentType !== 2 && tournamentEndDateLocal>now">
        <ng-container>
            <div class="discribe-time">
                <img src="assets/desktop/tournament/icon-tournament-type-{{isRegularTournament()?.tournamentType || 0}}.svg" alt="icon-tournament-type-{{isRegularTournament()?.tournamentType || 0}}">
                <span i18n>Time Left:</span>
                <div #tournamentstartdate></div>
            </div>
            <div class="badge-container batch-bg-0" *ngIf="isRegularTournament()?.tournamentType === 0 && !isRegularTournament()?.isPrivate">
                <img class="live-icon" src="assets/mobile/live.png" alt="badge-icon-0">
                <span i18n>Live</span>
            </div>
            <div class="badge-container batch-bg-1" *ngIf="isRegularTournament()?.tournamentType === 1">
                <img class="live-icon" src="assets/mobile/start-soon.png" alt="badge-icon-1">
                <span i18n>Starts Soon!</span>
            </div>
            <div class="badge-container batch-bg-3" *ngIf="isRegularTournament()?.isPrivate">
                <img class="live-icon" src="assets/mobile/icon-locked.png" alt="icon-locked">
                <span i18n>Locked</span>
            </div>
            <div class="badge-container batch-bg-9" *ngIf="tournament.isNetworkTournament">
                <img class="live-icon" src="assets/mobile/network.png" alt="icon-tournament-network">
                <span i18n>Network</span>
            </div>
        </ng-container>
    </div>
    <div class="description-time" *ngIf="tournamentStartDateLocal>now &&  tournamentEndDateLocal>now">
        <ng-container>
            <div class="discribe-time">
                <img src="assets/desktop/tournament/icon-tournament-type-1.svg" alt="icon-tournament-type-{{isRegularTournament()?.tournamentType}}">
                {{ tournamentStartDateLocal | date : 'short':'':locale
                }}<br />
            </div>
            <div class="badge-container batch-bg-1" *ngIf="isRegularTournament()?.tournamentType === 1">
                <img class="live-icon" src="assets/mobile/start-soon.png" alt="badge-icon-1">
                <span i18n>Starts Soon!</span>
            </div>
            <div class="badge-container batch-bg-2" *ngIf="isRegularTournament()?.tournamentType === 2">
                <img class="live-icon" src="assets/mobile/badge-icon-3.svg" alt="badge-icon-3">
                <span i18n>Completed</span>
            </div>
            <div class="badge-container batch-bg-9" *ngIf="tournament.isNetworkTournament">
                <img class="live-icon" src="assets/mobile/icon-tournament-network.svg" alt="icon-tournament-network">
                <span i18n>Network</span>
            </div>
        </ng-container>
    </div>
    <ng-container *ngIf="isRegularTournament()?.tournamentType === 2 || isFinished">
        <div class="description-time finished">
            <img src="assets/desktop/tournament/icon-completed-flag.svg" alt="icon-completed-flag">
            <span i18n>Finished</span>
        </div>
    </ng-container>
    <div class="descirption" [innerHTML]="description"></div>
</div>
